import React from 'react'
import {  } from "react-google-charts";

const InsightStatView =(props)=>{
    const {viewData, activeOption, deviceInfo} = props

    const currentOption = activeOption;// || viewData.DefaultOption;

    //var data = viewData.ViewData[currentOption].ChartData[1];
    const getPercentProps = (percentBetterMode, percentShowMode, progress, variance) => {
        // Returns { direction: 'up'|'down', color: '#hex' } or null
        let value = percentShowMode === 'P' ? progress : variance;

        if (percentBetterMode === 'P') {
            if (value > 0) return {direction: 'up', color: '#43a047' };      // Up green
            if (value < 0) return { direction: 'down', color: '#ff1744' };    // Down red
        } else if (percentBetterMode === 'N') {
            if (value < 0) return { direction: 'down', color: '#43a047' };    // Down green
            if (value > 0) return { direction: 'up', color: '#ff1744' };      // Up red
        }

        return null;
    }
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].StatData){
        
        // console.log("layout response view", viewData.ViewData[currentOption]);

        //default is ignore for percent show mode and percent better mode
        const percentShowMode = viewData.ViewOptions?.percentShowMode || 'I';
        const percentBetterMode = viewData.ViewOptions?.percentBetterMode || 'I';
        
        const percentProps = getPercentProps(percentBetterMode, percentShowMode, 
            viewData.ViewData[currentOption].StatData.ProgressPercent, 
            viewData.ViewData[currentOption].StatData.VariancePercent);

        return (
            <div className='uiInsightStatData'>
                <div className='uiFlexDistributed'>
                    <div className='uiFlexBox3'>
                        <span className='uiBold' style={{fontSize: '18px', color:'#0080ff'}}>{viewData.ViewData[currentOption].StatData.StatValueF}</span> 
                        <span className='' style={{fontSize: '12px'}}>{viewData.ViewData[currentOption].Y_AXIS_Title}</span>
                        {
                            viewData.ViewOptions?.showBaseLine || (0 === 1 && !deviceInfo.isTabletWidth && viewData.ViewData[currentOption].StatData.BaseLineValue !== 0 && (
                                <span className='' style={{fontSize: '12px', color:'#0080ff'}}>/ {viewData.ViewData[currentOption].StatData.BaseLineValueF}</span>
                            ))
                        } 
                    </div>
                    {percentShowMode !== 'I' && <div className='uiFlexBox3'>
                        {percentProps && percentBetterMode !== 'I' && (
                            <>
                                <svg width="16" height="16" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
                                    {percentProps.direction === 'up' ? (
                                        <polygon points="8,3 15,13 1,13" fill={percentProps.color} />
                                    ) : (
                                        <polygon points="8,13 15,3 1,3" fill={percentProps.color} />
                                    )}
                                </svg>
                            </>
                        )}
                        <span className='' style={{fontSize: '14px', color:'#0080ff'}}>{percentShowMode === 'P' ? viewData.ViewData[currentOption].StatData.ProgressPercentF : viewData.ViewData[currentOption].StatData.VariancePercentF}</span> 
                        <span className='' style={{fontSize: '12px'}}>%</span>
                    </div>}
                </div>
            </div>
        )
    }

    return null;
}

export default InsightStatView
